<template>
    <b-modal v-model="modal_desbloqueo.ver"
             size="sm"
             centered
    >
        <template #modal-header>
            <h6 class="mb-0">
                <i class="fa fa-unlock-alt"/> Desbloquear producto
            </h6>
        </template>

        <b-form method="POST"
                data-vv-scope="motivo"
        >
            <b-form-group label="Motivo:">
                <b-form-radio-group id="id_motivo_desbloqueo"
                                    name="id_motivo_desbloqueo"
                                    v-model="motivo.id_motivo_desbloqueo"
                                    v-validate="'required'"
                                    data-vv-as=" "
                >
                    <b-form-radio v-for="m in motivos"
                                  :value="m.id"
                                  :key="m.id"
                                  class="w-100"
                    >
                        {{ m.lista }}
                    </b-form-radio>
                </b-form-radio-group>

                <span class="text-danger span-error small"
                      v-text="errors.first('motivo.id_motivo_desbloqueo')"
                />
            </b-form-group>

            <b-row>
                <b-col>
                    <el-input id="nombre"
                              name="motivo"
                              type="textarea"
                              :rows="3"
                              v-if="motivoObligatorio"
                              v-model="motivo.motivo"
                              v-validate="{rules: {required: motivoObligatorio, min:5, max:255}}"
                              data-vv-as=" "
                    />

                    <span class="text-danger span-error small"
                          v-text="errors.first('motivo.motivo')"
                    />
                </b-col>
            </b-row>
        </b-form>

        <template #modal-footer>
            <div class="w-100 text-center">
                <b-btn @click="validarFormulario"
                       variant="primary"
                       size="sm"
                >
                    <i class="fa fa-save"/> Guardar
                </b-btn>
            </div>
        </template>
    </b-modal>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
    name: 'modal_desbloqueo',
    computed: {
        ...mapState('productos', [
            'modal_desbloqueo',
            'motivos',
            'motivo'
        ]),
        motivoObligatorio() {
            if (!!this.motivo.id_motivo_desbloqueo) {
                const motivo = this.motivos.find(m => m.id === this.motivo.id_motivo_desbloqueo);

                if (motivo && motivo.lista.toLowerCase().trim() === 'otro') {
                    return true;
                }
            }

            return false;
        }
    },
    methods: {
        ...mapActions('productos', [
            'desbloquearProducto'
        ]),
        validarFormulario() {
            this.$validator.validateAll('motivo')
                .then(async (result) => {
                    if (result) {
                        await this.desbloquearProducto();
                        this.$emit('desbloqueado');
                    }
                });
        }
    }
};
</script>

<style scoped>

</style>
